/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type StartMcpResearchSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type StartMcpResearchSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type StartMcpResearchSecurity = {
  option1?: StartMcpResearchSecurityOption1 | undefined;
  option2?: StartMcpResearchSecurityOption2 | undefined;
};

export type StartMcpResearchRequest = {
  /**
   * The approval request ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type StartMcpResearchSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const StartMcpResearchSecurityOption1$outboundSchema: z.ZodMiniType<
  StartMcpResearchSecurityOption1$Outbound,
  StartMcpResearchSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function startMcpResearchSecurityOption1ToJSON(
  startMcpResearchSecurityOption1: StartMcpResearchSecurityOption1,
): string {
  return JSON.stringify(
    StartMcpResearchSecurityOption1$outboundSchema.parse(
      startMcpResearchSecurityOption1,
    ),
  );
}

/** @internal */
export type StartMcpResearchSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const StartMcpResearchSecurityOption2$outboundSchema: z.ZodMiniType<
  StartMcpResearchSecurityOption2$Outbound,
  StartMcpResearchSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function startMcpResearchSecurityOption2ToJSON(
  startMcpResearchSecurityOption2: StartMcpResearchSecurityOption2,
): string {
  return JSON.stringify(
    StartMcpResearchSecurityOption2$outboundSchema.parse(
      startMcpResearchSecurityOption2,
    ),
  );
}

/** @internal */
export type StartMcpResearchSecurity$Outbound = {
  Option1?: StartMcpResearchSecurityOption1$Outbound | undefined;
  Option2?: StartMcpResearchSecurityOption2$Outbound | undefined;
};

/** @internal */
export const StartMcpResearchSecurity$outboundSchema: z.ZodMiniType<
  StartMcpResearchSecurity$Outbound,
  StartMcpResearchSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => StartMcpResearchSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => StartMcpResearchSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function startMcpResearchSecurityToJSON(
  startMcpResearchSecurity: StartMcpResearchSecurity,
): string {
  return JSON.stringify(
    StartMcpResearchSecurity$outboundSchema.parse(startMcpResearchSecurity),
  );
}

/** @internal */
export type StartMcpResearchRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const StartMcpResearchRequest$outboundSchema: z.ZodMiniType<
  StartMcpResearchRequest$Outbound,
  StartMcpResearchRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function startMcpResearchRequestToJSON(
  startMcpResearchRequest: StartMcpResearchRequest,
): string {
  return JSON.stringify(
    StartMcpResearchRequest$outboundSchema.parse(startMcpResearchRequest),
  );
}
